<template>
  <div class="hello" style="position:relative;width: 100%">
    <img src="static/bg.png" style="position:absolute;width: 100%;">
    <img src="static/logo.png" style="position:fixed;width: 15%;right:10px;top: 10px;">
    <img src="static/Pic_1.png" style="position:fixed;width: 49%;top: 10%;left: 2%">
    <div style="position:fixed;width: 35%;top: 10%;right: 5%">
      <p>书法老师</p>
      <p>APP</p>
      <p>扫码上课</p>
      <p>任e书</p>
      <p>欣赏</p>
      <p>签到得积分,轻松换购</p>
    </div>
    <img src="static/pic_2.png" style="position:fixed;width: 55%;top: 50%;right: 2%">
    <div style="position:fixed;width: 35%;top: 57%;right: 58%;display: flex">
      <div style="text-align: center;margin-top: 5px;color: #3b99dc">
        开始书写吧
      </div>
      <div>
        <img src="static/pic_jt.png" style="width: 30px;margin-left: 10px">
      </div>
    </div>
    <img src="static/qr_code.png" style="position:fixed;width: 25%;bottom: 5%;left: 2%">
    <a  target="_blank" href="static/app.apks" >
      <img src="static/btn.png" style="position:fixed;width: 25%;bottom: 10%;left: 30%" to="/static/app.apk">
    </a>
    <div style="position:fixed;bottom: 1px;text-align: center;width: 100%;font-size: 8px;color: white">
      技术支持
      电话:13333333333
      QQ:1111111111
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
p {
  color: #ffffff;
  padding: 0px;
  margin: 0px 5px 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue